import type { IConversation, IMessage } from "@src/types/AppTypes";
import { createContext } from "react";

export const ChatContext = createContext<IConversation>({} as IConversation);

export const ChatDispatchContext = createContext<
  React.Dispatch<
    | { payload: IConversation; type: "updateConversation" }
    | { payload: IMessage; type: "updateMessages" }
    | { payload: IMessage; type: "editMessage" }
    | { payload: IMessage[]; type: "prependChat" }
    | { payload: string; type: "deleteMessage" }
  >
>(() => { });

export const ChatIdContext = createContext<number>(0);

export const ChatIdDispatchContext = createContext<
  React.Dispatch<{ type: "updateChatId"; payload: number }>
>(() => { });

export function chatReducer(
  state: IConversation,
  action:
    | { payload: IConversation; type: "updateConversation" }
    | { payload: IMessage; type: "updateMessages" }
    | { payload: IMessage; type: "editMessage" }
    | { payload: IMessage[]; type: "prependChat" }
    | { payload: string; type: "deleteMessage" }
) {
  switch (action.type) {
    case "updateMessages":
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    case "editMessage": {
      const newMessages = state.messages;
      const index = newMessages.findIndex(i => i.id === action.payload.id)
      if (index > -1) {
        newMessages[index] = action.payload;
      }
      return {
        ...state,
        messages: newMessages,
      };
    }
    case "updateConversation":
      return action.payload;
    case "deleteMessage":
      return { ...state, messages: state.messages.filter((item) => item.id !== +action.payload) };
    case "prependChat":
      return {
        ...state,
        messages: [...action.payload, ...state.messages],
      };

    default:
      return state;
  }
}

export function chatIdReducer(
  state: number,
  action: { type: "updateChatId"; payload: number }
) {
  if (action.type === "updateChatId") {
    return action.payload;
  }
  else {
    return state;
  }
}
